import React, { lazy } from 'react';

// Use lazy loading to break circular dependencies
const ItemDetailsTab = lazy(() => import('./itemDetails/ItemDetailsTab'));
const InterchangeableItem = lazy(() => import('./InterchangeableItem'));
const ItemInventory = lazy(() => import('./ItemInventory')); // This fixes the undefined issue
const ItemWhConfig = lazy(() => import('./configuration/ItemWhConfig'));
const ItemAdditionalAttributes = lazy(() => import('./ItemAdditionalAttributes'));
const ChildItems = lazy(() => import('./ChildItems'));
const Document = lazy(() => import('./Document'));

export const ITEM_TABS = {
    details: {
        label: "Details",
        component: ItemDetailsTab
    },
    interchangeable: {
        label: "Interchangeable",
        component: InterchangeableItem
    },
    inventory: {
        label: "Inventory",
        component: ItemInventory
    },
    configuration: {
        label: "Configuration",
        component: ItemWhConfig
    },
    additional_attribute: {
        label: "Additional Attributes",
        component: ItemAdditionalAttributes
    },
    // child_item: {
    //     label: "Child Items",
    //     component: ChildItems
    // },
    document: {
        label: "Document",
        component: Document
    }
};